export interface CallsSessionRecord {
  readonly id: string;
  readonly session: string;
  readonly category: string;
}

const CALLS_SESSION_REGISTRY: readonly CallsSessionRecord[] =
Object.freeze([
  {
    id: 'audio',
    session: 'Audio Session',
    category: 'direct',
  },
  {
    id: 'video',
    session: 'Video Session',
    category: 'direct',
  },
  {
    id: 'group',
    session: 'Family Group Session',
    category: 'family',
  },
  {
    id: 'scheduled',
    session: 'Scheduled Session',
    category: 'planning',
  },
  {
    id: 'emergency',
    session: 'Emergency Session',
    category: 'priority',
  },
]);

export function getCallsSessionRegistry():
readonly CallsSessionRecord[] {
  return CALLS_SESSION_REGISTRY;
}
